import { render, staticRenderFns } from "./ValidationForm.vue?vue&type=template&id=73b48726&scoped=true&"
import script from "./ValidationForm.vue?vue&type=script&lang=js&"
export * from "./ValidationForm.vue?vue&type=script&lang=js&"
import style0 from "./ValidationForm.vue?vue&type=style&index=0&id=73b48726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b48726",
  null
  
)

component.options.__file = "ValidationForm.vue"
export default component.exports